import styles from "./NewRequest.module.css"
import {
    setErrorMessage,
    setInfoMessage,
    setLoading,
    useGlobalDispatch,
    useGlobalState
} from "../../context/GlobalState";
import React, {useEffect, useRef, useState} from "react";
import {
    getDomainRequestTypes,
    getPreSignedUrl,
    getTempFileLinks,
    sendInvoiceRequest,
    sendNewSubmission,
    sendSubmissionRequest
} from "../../services/api";
import axios from "axios";
import {IoReload} from "react-icons/io5";
import DynamicAttributes from "./DynamicAttributes";
import DynamicTextList from "./DynamicTextList";


// Convert a file to a Base64 string using the FileReader API.
const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            // The result is a data URL (e.g. "data:application/pdf;base64,...").
            // If desired, you can remove the prefix and keep only the Base64 part.
            let base64data = reader.result;
            if (typeof base64data === "string") {
                // Strip off the "data:*/*;base64," prefix if needed.
                const commaIndex = base64data.indexOf(",");
                if (commaIndex !== -1) {
                    base64data = base64data.substring(commaIndex + 1);
                }
                resolve(base64data);
            } else {
                reject("Unexpected result type");
            }
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
    });
};

const candidatesForAttributes = [
    'Nome',
    'RG',
    'CPF',
    'Endereço'
];

const candidatesForValidations = [
    'O documento pertence ao titular do seguro ou ao beneficiário autorizado.',
    'O nome e CPF/CNPJ do documento coincidem com os dados do contrato.',
    'A assinatura no documento é compatível com registros anteriores (se aplicável).',
    'O documento está dentro do prazo de validade (ex: CNH, RG, passaporte).',
    'O documento está completo, sem cortes, rasuras ou edições visíveis.',
    'O conteúdo está legível e em boa qualidade (sem borrões, sombras ou reflexos).',
    'O documento apresentado é aceito para o tipo de sinistro informado.',
    'O documento é oficial e válido em território nacional.',
    'O documento não apresenta indícios de falsificação ou adulteração.',
    'A data de emissão está visível e válida.',
    'O número do documento (ex: número do boletim de ocorrência, nota fiscal) está presente.',
    'A descrição do ocorrido está clara, quando aplicável (ex: no BO ou declaração).',
    'O documento comprova vínculo com o evento sinistrado (ex: nota fiscal de bem danificado, laudo técnico).',
    'No caso de terceiros, o documento comprova a relação com o sinistro (ex: boletim de ocorrência mencionando a parte envolvida).',
    'A data do documento está compatível com a data do sinistro.',
    'O documento foi enviado no formato exigido (PDF, JPG, etc.).',
    'As páginas/versos necessários estão incluídos (ex: frente e verso do RG).',
    'O envio está completo e dentro do prazo estipulado pela seguradora.',
];


const NewRequest = ({callbackOnSubmit})=> {
    const dispatch = useGlobalDispatch();
    const {theme, layout, profile, loading} = useGlobalState();
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [detail, setDetail] = useState(null);
    const fileInputRef = useRef(null);
    const [fileSendMode, setFileSendMode] = useState("pre-signed link");
    const [requestTypes, setRequestTypes] = useState([]);
    const [selectedRequestType, setSelectedRequestType] = useState([]);
    const [attributes, setAttributes] = useState([
        { name: candidatesForAttributes[0],  value: null },
    ]);
    const [validations, setValidations] = useState([candidatesForValidations[0]]);
    const [prompt, setPrompt] = useState(null);

    useEffect(()=> {
        const local_fetch = async ()=> {
            const data = await getDomainRequestTypes();
            setRequestTypes(data);
            if (!selectedRequestType || selectedRequestType.length<= 0) {
                setSelectedRequestType(data[0].value);
            }
        }
        local_fetch();
    }, []);


    // Handle file selection. Limit selection to a maximum of 3 files.
    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        // if (selectedFiles.length > 3) {
        //     setError("Please select up to 3 documents only.");
        //     return;
        // }
        setFiles(selectedFiles);
    };


    // Handle form submission.
    const handleSubmit = async (event) => {
        event.preventDefault();

        // if (!files || files.length === 0) {
        //     setError("Please select at least one document to submit.");
        //     return;
        // }
        setUploading(true);
        dispatch(setLoading(true));

        try {
            // Convert each file to Base64.
            const documents = await Promise.all(
                files.map(async (file) => {
                    if (fileSendMode === "base64") {
                        console.log( "User base64")
                        const base64Content = await fileToBase64(file);
                        return {
                            file_name: file.name,
                            content_type: file.type,
                            content: base64Content,
                        };
                    } else {  //pre-link
                        console.log( "User pre-signed link")

                        // 1. Get the pre-signed URL for this file.
                        //    (Assuming getPreSignedUrl returns a URL string.)
                        const presignedUrl = await getPreSignedUrl(file.type, file.name);

                        // 2. Upload the file as bytes to the pre-signed URL.
                        //    Here we are using a PUT request, which is commonly used with storage services.
                        const uploadResponse = await axios.put(presignedUrl, file, {
                            headers: {
                                "Content-Type": file.type,
                            }
                        });

                        // 3. Return the document object.
                        //    Instead of sending "content" (Base64), we now send "file_url".
                        return {
                            file_name: file.name,
                            content_type: file.type,
                            file_url: presignedUrl, // You may need to adjust this if your public URL is different.
                        };
                    }
                })
            );


            // attributes
            const filteredAttributes = attributes.filter(
                ({ name, value }) => name != null && value != null
            ).map(({name, value}) => { return {attribute_name: name, attribute_value: value}});;

            // valdations
            const filteredValidations = validations.filter(
                s => s != null && s.trim() !== ''
            ).map((s,idx) => { return {inquiry_id: String(idx+1), inquiry_text: s}});

            // Build the payload matching your API schema.
            const payload = {
                request_type: selectedRequestType, // Default or may be overridden by your API's logic.
                // Optionally add:
                // request_client_id: "your-client-id",
                // result_notify_callback_url: "http://your.callback.url",
                documents: documents,
                // result_callback_url: callbackUrl,
                // request_client_id: requestClientId,
                attributes: filteredAttributes,
                validations: filteredValidations,
            };
            if (prompt && prompt.length>0) {
                payload.prompt = prompt;
            }
            const response = await sendSubmissionRequest(payload);

            // Handle the response as needed.
            console.log("Response from API:", response);
            dispatch(setInfoMessage(`documents submitted successfully. response: ${JSON.stringify(response)}`))
            // Reset file input if desired.
            setFiles([]);
            if (fileInputRef.current) {
                fileInputRef.current.value = null;   // or ""
            }

            if (callbackOnSubmit) callbackOnSubmit();
        } catch (payload) {
            // setError(`Error: ${payload.message ?? JSON.stringify(payload)}`);
            dispatch(setErrorMessage(payload));
        } finally {
            setUploading(false);
            dispatch(setLoading(false));
        }
    };

    const divSelectBase64 = (
        <div>
            <label>
                <input
                    type="radio"
                    value="base64"
                    checked={fileSendMode === "base64"}
                    onChange={(e) => setFileSendMode(e.target.value)}
                />
                Base64
            </label>
            <label>
                <input
                    type="radio"
                    value="pre-signed link"
                    checked={fileSendMode === "pre-signed link"}
                    onChange={(e) => setFileSendMode(e.target.value)}
                />
                Pre-signed Link
            </label>
            {/*<p>Selected mode: {fileSendMode}</p>*/}
        </div>
    )


    const divPanel = (
        <div className={styles['top-panel']}>
            {/*<h1>Invoice Requests</h1>*/}
            <div className={styles['panel-form']}
            >
                {/*{error && <div style={{color: "red", marginBottom: "1rem"}}>{error}</div>}*/}

                <div className={styles['input-panel']}>
                    <h3>Tipo de processamento:</h3>
                    <div className={styles['type-selection']}>
                        <select
                            id={"requestType"}
                            value={selectedRequestType}
                            onChange={(e) => setSelectedRequestType(e.target.value)}
                        >
                            <option value="" disabled>
                                -- choose one --
                            </option>
                            {requestTypes.map(rt => (
                                <option key={rt.value} value={rt.value}>
                                    {rt.name}
                                </option>
                            ))}
                        </select>
                        <div>Selected value: {selectedRequestType || 'none'}</div>
                    </div>

                    <h3>Arquivos:</h3>
                    <div style={{display: "flex", flexDirection: "row", gap: "8px", alignItems: "center"}}>
                        <label htmlFor="fileInput">Select documents: </label>
                        <input
                            ref={fileInputRef}
                            style={{minWidth: "300px"}}
                            id="fileInput"
                            type="file"
                            accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                            multiple
                            onChange={handleFileChange}
                        />
                    </div>
                    {files && files.map((f, index) => <div className={styles['selected-files']}>
                        <div>{f.name}</div>
                    </div>)}
                    <h3>Forma de upload:</h3>
                    {divSelectBase64}
                    {/*<div style={{display: "flex", flexDirection: "row", gap: "8px", alignItems: "center"}}>*/}
                    {/*    <label htmlFor="callback_url">Callback url</label>*/}
                    {/*    <input*/}
                    {/*        type="text"*/}
                    {/*        style={{minWidth: "500px"}}*/}
                    {/*        value={callbackUrl}*/}
                    {/*        onChange={(e) => setCallbackUrl(e.target.value)}*/}
                    {/*    />*/}

                    {/*</div>*/}
                    {/*<div style={{display: "flex", flexDirection: "row", gap: "8px", alignItems: "center"}}>*/}
                    {/*    <label htmlFor="requestClientId">Request client id</label>*/}
                    {/*    <input*/}
                    {/*        type="text"*/}
                    {/*        style={{minWidth: "200px"}}*/}
                    {/*        value={requestClientId}*/}
                    {/*        onChange={(e) => setRequestClientId(e.target.value)}*/}
                    {/*    />*/}

                    {/*</div>*/}
                    <h3>Parâmetros:</h3>
                    <DynamicAttributes
                        value={attributes}
                        onChange={setAttributes}
                        candidates={candidatesForAttributes}
                    />

                    <h3>Validações:</h3>
                    <DynamicTextList
                        value={validations}
                        onChange={setValidations}
                        candidates={candidatesForValidations}
                    />
                    <h3>Comando opcional:</h3>
                    <div className={styles["prompt-div"]}>
                        <textarea
                            className={"textarea"}
                            value={prompt}
                            onChange={e => setPrompt(e.target.value)}
                            ></textarea>
                    </div>


                </div>
                <div className={styles['button-panel']}>
                    <button type="submit"
                            onClick={handleSubmit}
                            disabled={uploading}
                            className={'button-alert'}>
                        {uploading ? "Submitting..." : "Submit!"}
                    </button>
                </div>
            </div>
            {/*{divDateRange}*/}
            {/*<div className={styles["icons-panel"]}>*/}
            {/*    <button type="button"*/}
            {/*            onClick={(e) => fetchRequestList()}*/}
            {/*            className={'button-alert  -with-icon'}>*/}
            {/*        Load*/}
            {/*        <IoReload/>*/}
            {/*    </button>*/}
            {/*    <button type="button"*/}
            {/*            onClick={(e) => fetchRequestListApiVersion()}*/}
            {/*    >*/}
            {/*        Load using API version*/}
            {/*    </button>*/}
            {/*</div>*/}
            {/*{listDiv}*/}
        </div>
    )



    return <div className={styles['container']}>
        <h3>Nova submissão</h3>
        {divPanel}
    </div>
}

export default NewRequest;